export const Aspirantes = {
	LISTAR: 'aspirantes',
	IMPORTAR: 'aspirantes/importar',
	CREAR: 'aspirantes',
	BLOQUEAR: (ficha) => `aspirantes/bloquear/${ficha}`,
	DESBLOQUEAR: (ficha) => `aspirantes/desbloquear/${ficha}`,
	OBTENER: (ficha) => `aspirantes/${ficha}`,
	EDITAR: (ficha) => `aspirantes/${ficha}`,
	RESTABLECER_CONTRASENIA: (ficha) => `aspirantes/editar/contrasenia/${ficha}`,
	ELIMINAR: (ficha) => `aspirantes/${ficha}`,
	ELIMINAR_TODOS: 'aspirantes'
};

export const Examenes = {
	LISTAR: 'examenes',
	CREAR: 'examenes',
	OBTENER: (clave) => `examenes/${clave}`,
	EDITAR_ENCABEZADO: (clave) => `examenes/editar/encabezado/${clave}`,
	AGREGAR_AREA_DE_CONOCIMIENTO: (clave) => `examenes/agregar/area/${clave}`,
	AGREGAR_SECCION: (clave) => `examenes/agregar/seccion/${clave}`,
	AGREGAR_PREGUNTA: (clave) => `examenes/agregar/pregunta/${clave}`,
	QUITAR_PREGUNTA: (clave) => `examenes/quitar/pregunta/${clave}`,
	ACTUALIZAR_ESTATUS_FIJA_PREGUNTA: (clave) =>
		`examenes/editar/pregunta/estatus/${clave}`,
	EDITAR_AREA_DE_CONOCIMIENTO: (clave) => `examenes/editar/area/${clave}`,
	EDITAR_SECCION: (clave) => `examenes/editar/seccion/${clave}`,
	ELIMINAR: (clave) => `examenes/${clave}`,
	QUITAR_SECCION: (clave) => `examenes/quitar/seccion/${clave}`,
	QUITAR_AREA: (clave) => `examenes/quitar/area/${clave}`
};

export const BancosDePreguntas = {
	LISTAR: 'bancosDePreguntas',
	CREAR: 'bancosDePreguntas',
	IMPORTAR: 'bancosDePreguntas/importar',
	OBTENER: (claveExamen) => `bancosDePreguntas/${claveExamen}`,
	EDITAR_ENCABEZADO: (clave) => `bancosDePreguntas/editar/encabezado/${clave}`,
	ELIMINAR: (clave) => `bancosDePreguntas/${clave}`,
	CREAR_PREGUNTA: (clave) => `bancosDePreguntas/preguntas/crear/${clave}`,
	EDITAR_PREGUNTA: (clave) => `bancosDePreguntas/preguntas/editar/${clave}`,
	ELIMINAR_PREGUNTA: (clave) => `bancosDePreguntas/preguntas/eliminar/${clave}`
};

export const Planteles = {
	LISTAR: 'planteles',
	CREAR: 'planteles',
	ELIMINAR_TODOS: 'planteles'
};

export const Especialidades = {
	LISTAR: 'especialidades',
	CREAR: 'especialidades',
	ELIMINAR_TODOS: 'especialidades'
};
export const Materias = {
	LISTAR: 'materias',
	CREAR: 'materias',
	ELIMINAR_TODOS: 'materias'
};

export const Carreras = {
	LISTAR: 'carreras',
	CREAR: 'carreras',
	ELIMINAR_TODOS: 'carreras'
};
export const Aulas = {
	LISTAR: 'aulas',
	CREAR: 'aulas',
	ELIMINAR_TODOS: 'aulas'
};

export const Periodos = {
	LISTAR: 'periodos',
	CREAR: 'periodos',
	ELIMINAR_TODOS: 'periodos'
};

export const Personal = {
	LISTAR: 'personal',
	OBTENER: (clavePersonal) => `personal/${clavePersonal}`,
	CREAR: 'personal',
	EDITAR: (clavePersonal) => `personal/${clavePersonal}`,
	RESTABLECER_CONTRASENIA: (clavePersonal) =>
		`personal/editar/contrasenia/${clavePersonal}`,
	IMPORTAR: 'personal/importar',
	ELIMINAR: (clavePersonal) => `personal/${clavePersonal}`,
	ELIMINAR_TODOS: 'personal',
	OBTENER_ASPIRANTES: (clavePersonal) => `personal/aspirantes/${clavePersonal}`,
	CREAR_ASPIRANTES: (clavePersonal) => `personal/aspirantes/${clavePersonal}`,
	ASIGNAR_ASPIRANTES: 'personal/aspirantesV2',
	ELIMINAR_TODOS_ASPIRANTES: (clavePersonal) =>
		`personal/aspirantes/${clavePersonal}`,
	ELIMINAR_ASPIRANTE: (clavePersonal, ficha) =>
		`personal/aspirantes/${clavePersonal}/${ficha}`,
	ELIMINAR_TODOS_ASPIRANTE_PERSONAL: `personal/aspirantes`
};

export const Planes = {
	LISTAR: 'planes',
	LISTAR_PLANES_ACTIVOS: (claveCarrera) =>
		`reticulas/PlanesActivos/${claveCarrera}`,
	CREAR: 'planes',
	ELIMINAR_TODOS: 'planes'
};
export const Edificios = {
	LISTAR: 'edificios',
	CREAR: 'edificios',
	ELIMINAR_TODOS: 'edificios'
};

export const Departamentos = {
	LISTAR: 'departamentos',
	CREAR: 'departamentos',
	ELIMINAR_TODOS: 'departamentos'
};

export const Plantillas = {
	LISTAR: 'plantillas',
	CREAR: 'plantillas'
};

export const Reticulas = {
	LISTAR: 'reticulas',
	LISTAR_MATERIAS_CARRERA_PLAN: (claveCarrera, clavePlan) =>
		`reticulas/MateriasCarreraPlan/${claveCarrera}/${clavePlan}`,
	CREAR: 'reticulas',
	ELIMINAR_TODOS: 'reticulas',
	DETALLE: (claveCarrera, ClavePlan) =>
		`reticulas/${claveCarrera}/${ClavePlan}`,
	DETALLEESPECIALIDAD: (claveCarrera, ClavePlan, claveEspecialidad) =>
		`reticulas/${claveCarrera}/${ClavePlan}/${claveEspecialidad}`
};

export const Kardex = {
	GET: 'kardex',
	LISTAR: (ficha) => `kardex/${ficha}`,
	CREAR: 'kardex',
	ELIMINAR_TODOS: 'kardex'
};

export const Adeudos = {
	GET: 'adeudos',
	LISTAR: (ficha) => `adeudos/${ficha}`,
	CREAR: 'adeudos',
	ELIMINAR_TODOS: 'adeudos',
	TIPOS_ADEUDOS: 'adeudos/Tipos'
};

export const OrdenAcceso = {
	LISTAR: 'ordenacceso',
	CREAR: 'ordenacceso',
	ELIMINAR_TODOS: 'ordenacceso'
};

export const carrerasCoordinador = {
	LISTAR: 'carreraCoordinador',
	CREAR: 'carreraCoordinador',
	ELIMINAR_TODOS: 'carreraCoordinador'
};

export const Grupos = {
	LISTAR: 'grupos',
	LISTAR_GRUPOS_BASE: 'grupos/GruposBase',
	CREAR: 'Grupos',
	ELIMINAR_TODOS: 'grupos',
	OBTENER: (clavePeriodo, claveMateria, claveGrupo) =>
		`Grupos/${clavePeriodo}/${claveMateria}/${claveGrupo}`
};
export const Roles = {
	LISTAR: 'roles',
	OBTENER_PERMISOS: 'roles/GetPermisos',
	CREAR: 'roles',
	ELIMINAR_TODOS: 'roles'
};

export const GruposParalelos = {
	LISTAR: 'gruposparalelos',
	LISTAR_CANDIDATOS: (claveMaestro) =>
		`GruposParalelos/Candidatos/${claveMaestro}`,
	CREAR: 'gruposparalelos',
	CREAR_UNO: 'gruposparalelos/Crear',
	ELIMINAR: '/GruposParalelos/Eliminar',
	ELIMINAR_TODOS: 'gruposparalelos'
};

export const Archivos = {
	LISTAR: 'actividadesArchivos',
	POST: 'actividadesArchivos'
};

export const Configuraciones = {
	OBTENER: 'configuraciones'
};

export const PermisosIndividuales = {
	OBTENER: (clavePersonal) => `permisos/${clavePersonal}`,
	EDITAR: (clavePersonal) => `permisos/${clavePersonal}`
};

export const ExamenesAspirantes = {
	OBTENER_ASPIRANTES: (clave) => `examenesAspirantes/examen/${clave}`,
	CREAR_ASPIRANTES: (clave) => `examenesAspirantes/examen/${clave}`,
	ELIMINAR_TODOS_ASPIRANTES: (clave) => `examenesAspirantes/examen/${clave}`,
	ELIMINAR_ASPIRANTE: (clave, ficha) => `examenesAspirantes/${ficha}`,
	OBTENER_EXAMEN_ASPIRANTE: (clave, ficha) => `examenesAspirantes/${ficha}`,
	ASOCIAR_ASPIRANTES: (ficha) => `examenesAspirantes/${ficha}`,
	OBTENER_ASPIRANTES_RESULTADOS: (clave) =>
		`examenesAspirantes/resultados/${clave}`,
	OBTENER_ASPIRANTE_RESULTADO: (ficha) =>
		`examenesAspirantes/examen/aspirante/${ficha}`,
	DESCARGAR_CSV_RESULTADOS_GLOBALES: (clave) =>
		`examenesAspirantes/resultadosGlobales/${clave}`,
	OBTENER_ASPIRANTES_RESULTADOS_DETALLE: (clave) =>
		`examenesAspirantes/examenes/aspirantes/detalle/${clave}`
};
